export const CONFIG = {
    client_name : "sto",
    client_display_name : "STO",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : ` https://esr.fe-bis.de/de/sto/`,
    plz_validation : (plz : string) => plz.length == 5,
    menu_items_sorting: ["fassade","heizung","keller","dach","fenster","solarthermie","photovoltaik","lueftung"],
    foerderung : true,
    plus_expanded: true,
    show_geg_info: false,
    one_click_house_type: true,
}